import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import API_BASE_URL from '../config';
import './FundingProjectsPage.css';

const FundingProjectsPage = () => {
  const navigate = useNavigate();
  const [ideas, setIdeas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fundedIds, setFundedIds] = useState([]);

  const fetchIdeas = useCallback(async () => {
    try {
      setLoading(true);
      const res = await fetch(`${API_BASE_URL}/api/pitches?category=${encodeURIComponent('User/Talent')}`);
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        alert(data.error || 'Failed to load student ideas.');
        setIdeas([]);
        return;
      }
      setIdeas(data.pitches || []);
    } catch (err) {
      console.error('Error loading funding ideas:', err);
      alert('Failed to load student ideas.');
      setIdeas([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchIdeas();
  }, [fetchIdeas]);

  const handleFund = (idea) => {
    if (!idea?._id) return;
    if (fundedIds.includes(idea._id)) return;
    setFundedIds((prev) => [...prev, idea._id]);
    alert(`Funding interest recorded for "${idea.fileName || 'this project'}".`);
  };

  return (
    <div className="funding-page">
      <div className="funding-page-inner">
        <div className="funding-head">
          <button type="button" className="funding-back" onClick={() => navigate('/')}>
            ← Back to home
          </button>
          <h1>Funding Zone</h1>
          <p>Browse student ideas and back the ones you want to support.</p>
        </div>

        {loading ? (
          <div className="funding-empty">Loading projects...</div>
        ) : ideas.length === 0 ? (
          <div className="funding-empty">No student ideas available right now.</div>
        ) : (
          <div className="funding-list">
            {ideas.map((idea, index) => {
              const isFunded = fundedIds.includes(idea._id);
              return (
                <article key={idea._id || index} className="funding-item">
                  <div className="funding-item-left">
                    <h2>{idea.fileName || `Idea ${index + 1}`}</h2>
                    {idea.note && <p className="funding-note">{idea.note}</p>}
                    <p className="funding-meta">
                      By {idea.userId?.name || idea.userId?.email || 'Student'} ·{' '}
                      {new Date(idea.uploadedAt || Date.now()).toLocaleDateString()}
                    </p>
                  </div>
                  <div className="funding-item-right">
                    <button
                      type="button"
                      className={`fund-btn ${isFunded ? 'fund-btn--done' : ''}`}
                      disabled={isFunded}
                      onClick={() => handleFund(idea)}
                    >
                      {isFunded ? 'Funded' : 'Fund the project'}
                    </button>
                  </div>
                </article>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default FundingProjectsPage;
